import { Stack, Typography, useTheme } from "@mui/material";
import { useCatalogContext } from "../context/useCatalogContext";
import { SummaryHeader } from "./SummaryHeader";
import { GridView } from "./GridView";
import { ListView } from "./ListView";
import { FoodsIllustrations, WhiteBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

export const CatalogSummary = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { catalogView, isCatalogEmpty } = useCatalogContext();

    if (isCatalogEmpty) {
        return (
            <WhiteBox>
                <Stack
                    justifyContent={"center"}
                    alignItems={"center"}
                    padding={theme.spacing(2)}
                    gap={theme.spacing(1)}
                >
                    <FoodsIllustrations illustration="underConstruction" />
                    <Typography variant="big-bold">
                        {t("action_plan.no_possible_actions", "Your action plan has no possible actions yet")}
                    </Typography>
                </Stack>
            </WhiteBox>
        );
    }

    return (
        <Stack>
            <Stack
                border={`1px solid ${theme.custom.grey[600]}`}
                borderRadius={"12px 12px 0px 0px"}
                padding={theme.spacing(2, 3)}
                bgcolor={theme.custom.grey[200]}
            >
                <SummaryHeader />
            </Stack>
            <Stack
                border={`1px solid ${theme.custom.grey[600]}`}
                borderTop={0}
                borderRadius={`0px 0px 12px 12px`}
                bgcolor={"white"}
            >
                {catalogView === "grid" ?
                    <GridView />
                :   <ListView />}
            </Stack>
        </Stack>
    );
};
